<div
    class="betslip-summary__token-payout-summary"
    *ngIf="summaryMessage != null && isRewardTokenSelectorVisible$ | async as isRewardTokenSelectorVisible"
    [ngClass]="{
        'betslip-summary__token-payout-summary--odds-boost': tokenType === RewardTokenType.OddsBoost,
        'betslip-summary__token-payout-summary--acca-boost theme-acca-boost': tokenType === RewardTokenType.AccaBoost,
    }"
    [innerHTML]="summaryMessage"></div>
